import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "@/lib/api";

const WhatsAppContext = createContext({
  template: "",
  setTemplate: async () => {},
  loaded: false,
});

export function useWhatsApp() {
  return useContext(WhatsAppContext);
}

export function WhatsAppProvider({ children }) {
  const [template, setTemplateState] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    api.get("/me/whatsapp")
      .then(({ data }) => { if (active) { setTemplateState(data.template || ""); setLoaded(true); } })
      .catch(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, []);

  const setTemplate = useCallback(async (t) => {
    const { data } = await api.put("/me/whatsapp", { template: t });
    setTemplateState(data.template || t);
    return data.template;
  }, []);

  const value = useMemo(
    () => ({ template, setTemplate, loaded }),
    [template, setTemplate, loaded]
  );

  return (
    <WhatsAppContext.Provider value={value}>
      {children}
    </WhatsAppContext.Provider>
  );
}
